import { route } from '../../../constants.ts';
import { VECTOR_FEATURE_TYPE_SOURCE } from '@repperjs/shared/src/utils/vector/vectorFeatureType.js';

export const CHANGE_VECTOR_SERVICE_STATE = `${route}/CHANGE_VECTOR_SERVICE_STATE`;
export const CHANGE_VECTOR_PREVIEW_IMAGE = `${route}/CHANGE_VECTOR_PREVIEW_IMAGE`;
export const CHANGE_VECTOR_FEATURES = `${route}/CHANGE_VECTOR_FEATURES`;

export function changeVectorServiceState({ id, type, serviceState }) {
    return {
        type: CHANGE_VECTOR_SERVICE_STATE,
        payload: { id, type, serviceState },
    };
}

export function changeVectorPreviewImage(image) {
    return {
        type: CHANGE_VECTOR_PREVIEW_IMAGE,
        payload: { image },
    };
}

/**
 * use this action when features are calculated
 * @param {Features} features
 * @param {VectorFeatureType} type
 * @returns {{payload : {features, type : string}, type : string}}
 */
export function changeVectorFeatures({ features, type = VECTOR_FEATURE_TYPE_SOURCE }) {
    return {
        type: CHANGE_VECTOR_FEATURES,
        payload: { features, type },
    };
}
